import { AppApi } from '../helpers/AppApi';

export const httpClient = new AppApi();
